import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableHeaderCell,
  Text,
  Checkbox
} from '../../../../../components';

const DataDictionaryTable = styled(Table)`
  table-layout: fixed;
  border-collapse: collapse;
`;

const ColumnNameHeaderCell = styled(TableHeaderCell)`
  width: 25%;
`;
const DescriptionHeaderCell = styled(TableHeaderCell)`
  width: auto;
`;
const CheckboxHeaderCell = styled(TableHeaderCell)`
  width: 80px;
  text-align: right;
`;

const BaseCell = styled(TableCell)`
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
const ColumnNameCell = styled(BaseCell)`
  width: 25%;
`;
const DescriptionCell = styled(BaseCell)`
  width: auto;
`;
const CheckboxCell = styled(BaseCell)`
  text-align: right;
  width: 80px;
`;

const StyledCheckbox = styled(Checkbox)``;

const DatabaseDescriptionTable = ({
  table,
  selectedTable,
  onToggleColumnCheckbox = null,
  selectedItems = [],
  isReadOnly = false
}) => (
  <DataDictionaryTable>
    <TableHead>
      <TableRow>
        <ColumnNameHeaderCell>
          <Text as='span' $bold $color='var(--content-subtitle)'>
            Column Name
          </Text>
        </ColumnNameHeaderCell>
        <DescriptionHeaderCell>
          <Text as='span' $bold $color='var(--content-subtitle)'>
            Description
          </Text>
        </DescriptionHeaderCell>
        <DescriptionHeaderCell>
          <Text as='span' $bold $color='var(--content-subtitle)'>
            Sample Values
          </Text>
        </DescriptionHeaderCell>
        {onToggleColumnCheckbox && !isReadOnly && (
          <CheckboxHeaderCell>
            <Text as='span' $bold $color='var(--content-subtitle)'>
              Select to add
            </Text>
          </CheckboxHeaderCell>
        )}
      </TableRow>
    </TableHead>
    <TableBody>
      {table?.columns.map((column) => (
        <TableRow key={column.name}>
          <ColumnNameCell>
            <Text as='span' $bold>
              {column.name}
            </Text>
          </ColumnNameCell>
          <DescriptionCell>
            <Text as='span'>{column.description}</Text>
          </DescriptionCell>
          <DescriptionCell>
            <Text as='span'>{column.enumeratedValues?.slice(0, 3)?.join(', ')}</Text>
          </DescriptionCell>
          {onToggleColumnCheckbox && !isReadOnly && (
            <CheckboxCell>
              <StyledCheckbox
                onChange={() =>
                  onToggleColumnCheckbox({
                    value: column.name,
                    table: selectedTable,
                    tag: '@',
                    columnDescription: column.description,
                    enumeratedValues: column.enumeratedValues
                  })
                }
                value={column.name}
                checked={selectedItems.some(
                  (selectedColumn) =>
                    selectedColumn.value === column.name &&
                    selectedColumn.table === selectedTable &&
                    selectedColumn.tag === '@'
                )}
              />
            </CheckboxCell>
          )}
        </TableRow>
      ))}
    </TableBody>
  </DataDictionaryTable>
);

DatabaseDescriptionTable.propTypes = {
  table: PropTypes.shape({
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  onToggleColumnCheckbox: PropTypes.func,
  selectedTable: PropTypes.string.isRequired,
  selectedItems: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      table: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    })
  ),
  isReadOnly: PropTypes.bool
};

export { DatabaseDescriptionTable };
